(function () {
  // Free-gift Note Book auto-add, Rs 3,000+ threshold.
  // Threshold comparison fixed 6 Oct 2026 (revision 2).
  //
  // BUG FIXED THIS ROUND:
  // A single book at Rs 3,090 never received a notebook, yet the Rs 120
  // order-level credit still applied — so the customer got Rs 120 off and
  // no gift. The script summed item.line_price, which moves with discounts,
  // so once the Rs 120 credit landed the computed subtotal fell below the
  // Rs 3,000 threshold and the script concluded no gift was due. Carts well
  // above the threshold (Rs 3,830) were unaffected, which is why this only
  // appeared near the boundary. Left alone it could also flap: add gift ->
  // credit applies -> subtotal drops -> gift removed -> credit drops...
  //
  // We now use cart.items_subtotal_price: the total after LINE-level
  // discounts but before CART-level discounts — the same figure Shopify
  // tests the order discount's minimum against. Script and discount now
  // agree by construction, and the credit cannot feed back into the
  // decision that produced it.

  if (window.__rwGiftNotebookInit) return;
  window.__rwGiftNotebookInit = true;

  var GIFT_VARIANT_ID = 47521233862901; // Note Book — Default Title
  var THRESHOLD = 3000;
  var POLL_INTERVAL = 30000;
  var DEBOUNCE_MS = 450;
  var MAX_FAILURES = 3;
  var ADDED_FLAG = 'rw_gift_added';

  var isProcessing = false;
  var debounceTimer = null;
  var failures = 0;
  var disabled = false;
  var pollTimer = null;
  var suppressObserver = false;

  function weAddedIt() {
    try { return sessionStorage.getItem(ADDED_FLAG) === '1'; } catch (e) { return false; }
  }
  function setWeAddedIt(v) {
    try { v ? sessionStorage.setItem(ADDED_FLAG, '1') : sessionStorage.removeItem(ADDED_FLAG); } catch (e) {}
  }

  function giveUp(why) {
    disabled = true;
    if (pollTimer) clearInterval(pollTimer);
    console.warn('[rw-gift] disabled: ' + why);
  }
  function noteFailure(why) {
    failures++;
    console.warn('[rw-gift] failed (' + failures + '/' + MAX_FAILURES + '): ' + why);
    if (failures >= MAX_FAILURES) giveUp('too many consecutive failures; not retrying.');
  }

  async function getCart() {
    suppressObserver = true;
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('cart.js HTTP ' + res.status);
      return await res.json();
    } finally { suppressObserver = false; }
  }

  function giftLines(cart) {
    return (cart.items || []).filter(function (i) { return i.variant_id === GIFT_VARIANT_ID; });
  }

  async function changeLine(key, quantity) {
    suppressObserver = true;
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!res.ok) throw new Error('change.js HTTP ' + res.status);
      return await res.json();
    } finally { suppressObserver = false; }
  }

  async function addGift() {
    suppressObserver = true;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] })
      });
      if (!res.ok) {
        var detail = '';
        try { var d = await res.json(); detail = d.description || d.message || ''; } catch (e) {}
        throw new Error('add.js HTTP ' + res.status + (detail ? ' \u2014 ' + detail : ''));
      }
      return await res.json();
    } finally { suppressObserver = false; }
  }

  function qualifyingSubtotal(cart) {
    var base = cart.items_subtotal_price;
    if (typeof base !== 'number') {
      base = (cart.items || []).reduce(function (sum, i) {
        return sum + (typeof i.original_line_price === 'number' ? i.original_line_price : i.line_price);
      }, 0);
    }
    var giftPortion = giftLines(cart).reduce(function (sum, i) {
      return sum + (typeof i.original_line_price === 'number' ? i.original_line_price : i.line_price);
    }, 0);
    return (base - giftPortion) / 100;
  }

  async function normalize() {
    if (disabled || isProcessing) return;
    isProcessing = true;
    var changed = false;
    try {
      var cart = await getCart();
      var qualifies = qualifyingSubtotal(cart) >= THRESHOLD;
      var lines = giftLines(cart);
      var qty = lines.reduce(function (n, i) { return n + i.quantity; }, 0);

      if (qualifies && qty === 0) {
        await addGift();
        setWeAddedIt(true);
        changed = true;
      } else if (!qualifies && qty > 0 && weAddedIt()) {
        await changeLine(lines[0].key, Math.max(0, lines[0].quantity - 1));
        setWeAddedIt(false);
        changed = true;
      }

      failures = 0;
      if (changed) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        window.location.reload();
      }
    } catch (e) {
      noteFailure(e && e.message ? e.message : String(e));
    } finally {
      isProcessing = false;
    }
  }

  function scheduleNormalize() {
    if (disabled) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(normalize, DEBOUNCE_MS);
  }

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var watch = !suppressObserver && CART_WRITE.test(url);
      var p = nativeFetch.apply(this, arguments);
      if (watch) p.then(function (r) { if (r && r.ok) scheduleNormalize(); }, function () {});
      return p;
    };
  }
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rwGiftCartWrite = CART_WRITE.test(url || '');
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__rwGiftCartWrite && !suppressObserver) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) scheduleNormalize();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize);
  } else {
    normalize();
  }
  document.addEventListener('cart:updated', scheduleNormalize);
  pollTimer = setInterval(normalize, POLL_INTERVAL);
})();
